import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'processMarkdown', standalone: true })
export class ProcessMarkdownPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    value = value.replace(
      /@@/g,
      `<img src="assets/icons/checkmark.svg" alt="checkmark">`
    );

    value = value.replace(/^###### (.*)$/gm, '<h6>$1</h6>');
    value = value.replace(/^##### (.*)$/gm, '<h5>$1</h5>');
    value = value.replace(/^#### (.*)$/gm, '<h4>$1</h4>');
    value = value.replace(/^### (.*)$/gm, '<h3>$1</h3>');
    value = value.replace(/^## (.*)$/gm, '<h2>$1</h2>');
    value = value.replace(/^# (.*)$/gm, '<h1>$1</h1>');

    value = value.replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>');
    value = value.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    value = value.replace(/\*(.+?)\*/g, '<em>$1</em>');

    value = value.replace(/\n/g, '<br/>');

    return value;
  }
}
